(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-ui-react/use-status-bar-color/assets/use-status-bar-color.js') >= 0) return;  svs.modules.push('/components/tb-ui-react/use-status-bar-color/assets/use-status-bar-color.js');
'use strict';

const _React = React,
  useLayoutEffect = _React.useLayoutEffect;
const logger = svs.core.log.getLogger('component:useStatusBarColor');
const useStatusBarColor = id => {
  useLayoutEffect(() => {
    if (getComputedStyle && id) {
      var _document$querySelect;
      const el = document.getElementById(id);
      if (!el) {
        logger.info("Element with id ".concat(id, " not found"));
        return;
      }
      const color = getComputedStyle(el).backgroundColor;
      (_document$querySelect = document.querySelector('meta[name="theme-color"]')) === null || _document$querySelect === void 0 || _document$querySelect.setAttribute('content', color);
    }
  }, []);
};
svs.components.tb_ui_react.useStatusBarColor.useStatusBarColor = useStatusBarColor;

 })(window);